/* Product card hover video V2 — lazy load diamonds, hover play for non-diamonds */
(function() {
  var diamondObserver = null;

  if ('IntersectionObserver' in window) {
    diamondObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          /* Load sources if not yet loaded */
          if (!video._nuarLoaded) {
            video.querySelectorAll('source[data-src]').forEach(function(s) {
              s.src = s.getAttribute('data-src');
              s.removeAttribute('data-src');
            });
            video.preload = 'auto';
            video.load();
            video._nuarLoaded = true;
            /* Remove skeleton on canplay */
            var skeleton = video.parentElement && video.parentElement.querySelector('.diamond-video-skeleton');
            if (skeleton) {
              video.addEventListener('canplay', function() {
                skeleton.classList.add('loaded');
              }, { once: true });
            }
          }
          video.play().catch(function(){});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.1 });
  }

  function init() {
    document.querySelectorAll('product-card, .product-card').forEach(function(card) {
      var video = card.querySelector('.product-hover-video');
      if (!video) return;

      /* Diamond products: viewport-aware lazy loading */
      if (video.classList.contains('diamond-autoplay')) {
        if (diamondObserver) {
          diamondObserver.observe(video);
        } else {
          /* Fallback: no IntersectionObserver — eager load */
          video.querySelectorAll('source[data-src]').forEach(function(s) {
            s.src = s.getAttribute('data-src');
            s.removeAttribute('data-src');
          });
          video.preload = 'auto';
          video.load();
          video.play().catch(function(){});
          var sk = video.parentElement && video.parentElement.querySelector('.diamond-video-skeleton');
          if (sk) sk.classList.add('loaded');
        }
        return;
      }

      /* Non-diamond products: hover to play (unchanged) */
      var hoverImg = card.querySelector('.product-secondary-image');
      card.addEventListener('mouseenter', function() {
        video.style.opacity = '1';
        if (hoverImg) hoverImg.style.opacity = '0';
        video.play().catch(function(){});
      });
      card.addEventListener('mouseleave', function() {
        video.style.opacity = '0';
        if (hoverImg) hoverImg.style.opacity = '';
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();